/**
 * Routes
 */

// import VueCookies from 'vue-cookies'

// components
var Dashboard = resolve => require(['./views/Dashboard.vue'], resolve)
var NotFound = resolve => require(['./views/404.vue'], resolve)
var Login = resolve => require(['./views/Login.vue'], resolve)

module.exports = [
  { path: '/register', component: resolve => require(['./views/Register.vue'], resolve) },
  { path: '/login', component: Login },
  {
    name: '/signup',
    path: '/signup/:id',
    component: resolve => require(['./views/Signup.vue'], resolve)
  },
  { path: '/', redirect: '/dashboard' },
  { path: '/dashboard', component: Dashboard },
  {
    path: '/clients',
    component: resolve => require(['./views/client/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/client/index.vue'], resolve)
      },
      {
        path: 'add',
        component: resolve => require(['./views/client/add.vue'], resolve)
      },
      {
        name: 'edit-client',
        path: 'edit/:id',
        component: resolve => require(['./views/client/edit.vue'], resolve)
      }
    ]
  },
  {
    path: '/deadlines',
    component: resolve => require(['./views/deadlines/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/deadlines/index.vue'], resolve)
      },
      {
        path: 'add',
        component: resolve => require(['./views/deadlines/add.vue'], resolve)
      },
      {
        name: 'edit-client',
        path: 'edit/:id',
        component: resolve => require(['./views/deadlines/edit.vue'], resolve)
      }
    ]
  },
  /*
   * Settings related routes
   */
  {
    path: '/settings',
    component: resolve => require(['./views/settings/template.vue'], resolve),
    children: [
      {
        path: 'profile',
        component: resolve => require(['./views/settings/profile.vue'], resolve)
      },
      {
        path: '',
        component: resolve => require(['./views/settings/company-settings.vue'], resolve)
      },
      {
        path: 'add-region',
        component: resolve => require(['./views/settings/region/add.vue'], resolve)
      },
      {
        name: 'edit-region',
        path: 'edit-region/:id',
        component: resolve => require(['./views/settings/region/edit.vue'], resolve)
      },
      {
        path: 'add-location-grade',
        component: resolve => require(['./views/settings/location-grade/add.vue'], resolve)
      },
      {
        name: 'edit-location-grade',
        path: 'edit-location-grade/:id',
        component: resolve => require(['./views/settings/location-grade/edit.vue'], resolve)
      },
      {
        path: 'add-location-type',
        component: resolve => require(['./views/settings/location-type/add.vue'], resolve)
      },
      {
        name: 'edit-location-type',
        path: 'edit-location-type/:id',
        component: resolve => require(['./views/settings/location-type/edit.vue'], resolve)
      },
      {
        path: 'add-deadline-category',
        component: resolve => require(['./views/settings/deadline-category/add.vue'], resolve)
      },
      {
        name: 'edit-deadline-category',
        path: 'edit-deadline-category/:id',
        component: resolve => require(['./views/settings/deadline-category/edit.vue'], resolve)
      },
      {
        path: 'add-client-custom-field',
        component: resolve => require(['./views/settings/clientcustomfields/add.vue'], resolve)
      },
      {
        name: 'edit-client-custom-field',
        path: 'edit-client-custom-field/:id',
        component: resolve => require(['./views/settings/clientcustomfields/edit.vue'], resolve)
      },
      {
        path: 'add-tags',
        component: resolve => require(['./views/settings/tags/add.vue'], resolve)
      },
      {
        name: 'edit-tags',
        path: 'edit-tags/:id',
        component: resolve => require(['./views/settings/tags/edit.vue'], resolve)
      }
    ]
  },
  {
    path: '/fee-types',
    component: resolve => require(['./views/time-tracking/fee-types/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/time-tracking/fee-types/index.vue'], resolve)
      },
      {
        name: 'add-fee-type',
        path: 'add',
        component: resolve => require(['./views/time-tracking/fee-types/add.vue'], resolve)
      },
      {
        name: 'update-fee-type',
        path: 'update/:id',
        component: resolve => require(['./views/time-tracking/fee-types/update.vue'], resolve)
      }
    ]
  },
  {
    path: '/users',
    component: resolve => require(['./views/users/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/users/index.vue'], resolve)
      },
      {
        path: 'add',
        component: resolve => require(['./views/users/add.vue'], resolve)
      },
      {
        path: 'edit/:id',
        name: 'edit-user',
        component: resolve => require(['./views/users/edit.vue'], resolve)
      }
    ]
  },
  {
    path: '/checklists',
    component: resolve => require(['./views/task/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/task/index.vue'], resolve)
      },
      {
        path: 'add',
        component: resolve => require(['./views/task/add.vue'], resolve)
      },
      {
        path: 'edit/:id',
        name: 'edit-task',
        component: resolve => require(['./views/task/edit.vue'], resolve)
      }
    ]
  },
  {
    path: '/task-types',
    component: resolve => require(['./views/time-tracking/task-types/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/time-tracking/task-types/index.vue'], resolve)
      },
      {
        name: 'add-task-type',
        path: 'add',
        component: resolve => require(['./views/time-tracking/task-types/add.vue'], resolve)
      },
      {
        name: 'update-task-type',
        path: 'update/:id',
        component: resolve => require(['./views/time-tracking/task-types/update.vue'], resolve)
      }
    ]
  },
  {
    path: '/time-sheets',
    component: resolve => require(['./views/time-tracking/tasks/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/time-tracking/tasks/index.vue'], resolve)
      },
      {
        name: 'add-task',
        path: 'add',
        component: resolve => require(['./views/time-tracking/tasks/add.vue'], resolve)
      },
      {
        name: 'update-task',
        path: 'update/:id',
        component: resolve => require(['./views/time-tracking/tasks/update.vue'], resolve)
      },
      {
        name: 'bulk-add',
        path: 'bulk-add',
        component: resolve => require(['./views/time-tracking/tasks/bulkAdd.vue'], resolve)
      }
    ]
  },
  {
    path: '/reports',
    component: resolve => require(['./views/reports/template.vue'], resolve),
    children: [
      {
        path: 'user-tasks',
        component: resolve => require(['./views/reports/user-task-report.vue'], resolve)
      },
      {
        path: 'completed-tasks',
        component: resolve => require(['./views/reports/completed-task-report.vue'], resolve)
      },
      {
        path: 'client-revenue',
        component: resolve => require(['./views/reports/client-revenue-report.vue'], resolve)
      },
      {
        path: 'weekly-time',
        component: resolve => require(['./views/reports/weekly-time-report.vue'], resolve)
      }
    ]
  },
  {
    path: '/workflow',
    component: resolve => require(['./views/workflow/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/workflow/index.vue'], resolve)
      },
      {
        name: 'add',
        path: 'add',
        component: resolve => require(['./views/workflow/add.vue'], resolve)
      },
      {
        name: 'workflow-tasks',
        path: 'workflow-tasks/:id',
        component: resolve => require(['./views/workflow/workflow_tasks.vue'], resolve)
      },
      {
        name: 'all-my-tasks',
        path: 'all-my-tasks',
        component: resolve => require(['./views/workflow/all_my_tasks.vue'], resolve)
      },
      {
        name: 'continue-task',
        path: 'continue-task/:id',
        component: resolve => require(['./views/workflow/continue_workflow_task.vue'], resolve)
      },
      {
        name: 'load-task',
        path: 'load-task/:id',
        component: resolve => require(['./views/workflow/load_workflow_task.vue'], resolve)
      },
      {
        name: 'start-task',
        path: 'start-task/:id',
        component: resolve => require(['./views/workflow/start_workflow_task.vue'], resolve)
      },
      {
        path: 'edit/:id',
        name: 'edit-workflow',
        component: resolve => require(['./views/workflow/edit.vue'], resolve)
      },
      {
        name: 'all-tasks',
        path: 'all-tasks',
        component: resolve => require(['./views/workflow/all_tasks.vue'], resolve)
      }
    ]
  },
  {
    path: '/announcements',
    component: resolve => require(['./views/announcement/template.vue'], resolve),
    children: [
      {
        name: 'all',
        path: 'all',
        component: resolve => require(['./views/announcement/index.vue'], resolve)
      },
      {
        name: 'add-announcement',
        path: 'add',
        component: resolve => require(['./views/announcement/add.vue'], resolve)
      },
      {
        name: 'update-announcement',
        path: 'update/:id',
        component: resolve => require(['./views/announcement/update.vue'], resolve)
      }
    ]
  },
  {
    path: '/roles',
    component: resolve => require(['./views/roles/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/roles/index.vue'], resolve)
      },
      {
        name: 'add-role',
        path: 'add',
        component: resolve => require(['./views/roles/add.vue'], resolve)
      },
      {
        name: 'edit-role',
        path: 'edit/:id',
        component: resolve => require(['./views/roles/edit.vue'], resolve)
      }
    ]
  },
  {
    path: '/tasks',
    component: resolve => require(['./views/task/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/task/index.vue'], resolve)
      },
      {
        path: 'add',
        component: resolve => require(['./views/task/add.vue'], resolve)
      },
      {
        path: 'edit/:id',
        component: resolve => require(['./views/task/edit.vue'], resolve)
      }
    ]
  },
  {
    path: '/departments',
    component: resolve => require(['./views/department/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/department/index.vue'], resolve)
      },
      {
        path: 'add',
        component: resolve => require(['./views/department/add.vue'], resolve)
      },
      {
        path: 'edit/:id',
        name: 'update-department',
        component: resolve => require(['./views/department/update.vue'], resolve)
      }
    ]
  },
  {
    path: '/403',
    component: resolve => require(['./views/403.vue'], resolve)
  },
  {
    path: '/forgot-password',
    component: resolve => require(['./views/password/forgot.vue'], resolve)
  },
  {
    name: '/reset-password',
    path: '/reset-password/:id',
    component: resolve => require(['./views/password/reset.vue'], resolve)
  },
  {
    name: '/api/password/reset',
    path: '/api/password/reset/:id',
    component: resolve => require(['./views/password/reset.vue'], resolve)
  },
  { path: '*', component: NotFound }
]



// WEBPACK FOOTER //
// ./src/routes.js